import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('noResults', {
        template: '<h2>Brak wyników</h2>',
    });
})();



//////////////////
// WEBPACK FOOTER
// ./src/app/components/data-presentation/no-results/no-results.component.js
// module id = 534
// module chunks = 0